import { createSelector } from 'reselect'

const isSubscribed = (subscriptions, associationId) => subscriptions.includes(associationId);
export const makeIsSubscribed = () => createSelector(isSubscribed, subscribed => subscribed);
